module.exports = __webpack_public_path__ + "static/media/cryptocurrency.88532732.png";